module.exports = __webpack_public_path__ + "static/qhnz1-56ac0da8f86dcf5d6e93d31b0e106d7f.png";